import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { SearchResult } from '../../models/searchresult.model';
import { ProfileService } from 'src/app/profile/profile.service';
import { DataService } from 'src/app/shared/data.service';
import { CompanyCreditService } from 'src/app/profile/companyprofile/companycredit/companycredit.service';
import { UserService } from 'src/app/shared/user.service';
import { User } from 'src/app/shared/user.model';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.css']
})
export class ResultComponent implements OnInit {
  @Input() result: SearchResult;

  constructor(
    private profileService: ProfileService, 
    private dataService: DataService,
    private userService: UserService) { }

  getCleanPhoneForLink() {
    return "1" + this.result.Phone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "")
  }

  getCleanTollFreeForLink() {
    return "1" + this.result.TollFree.replace("(", "").replace(")", "").replace("-", "").replace(" ", "")
  }

  showCompany(event) {
    // Don't show modal if the click is on an external link (web, email, phone)
    if (event.srcElement.nodeName === 'A' || event.srcElement.parentElement.nodeName === 'A') {
      event.stopPropagation();
      return;
    }
    if (this.result.RecordType == "C") {
      this.profileService.showCompany(this.result);
      this.dataService.getCreditInfo(this.result.Id, this.result.Upic);
    }
    else {
      this.dataService.getIndividualProfile(this.result.Id);
    }
  }
  ngOnInit() {
  }
}
